const dataConsent = (
	<div>
		<h3>
			<b>CLAUSULA DE CONSENTIMIENTO PARA EL TRATAMIENTO DE DATOS PERSONALES DE MENORES</b>
		</h3>
		<p></p>
		<p>
			En relación con el tratamiento de los datos personales del menor o la menor así como de sus progenitores, tutores o representantes legales que se indican al final del
			presente documento, y de acuerdo a lo que establece el artículo 13 del Reglamento (UE) 2016/679, del Parlamento Europeo y del Consejo, de 27 de abril de 2016, relativo a la
			protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos y por el que se deroga la Directiva 95/46/CE:
			Reglamento general de protección de datos (DOUE L 119, de 4-5-2016), y el artículo 11 de la Ley Orgánica 3/2018, de 5 de diciembre, de protección de datos y garantía de los
			derechos digitales (BOE de 6-12-2018), se informa de lo siguiente:
		</p>
		<p>RESPONSABLE DEL TRATAMIENTO</p>
		<p>
			Federación Española de Fútbol, Plaza de Luis Aragonés, s/n<span>&nbsp; </span>28232 (Madrid)
		</p>
		<p>DATOS DE CONTACTO DEL DELEGADO DE PROTECCIóN DE DATOS</p>
		<p>
			Plaza de Luis Aragonés, s/n<span>&nbsp; </span>28232 (Madrid)
		</p>
		<p>DATOS PERSONALES QUE SE TRATARáN</p>
		<p>Datos personales del menor o la menor:</p>
		<p>1. Datos identificativos: nombre y apellidos, NIF/Pasaporte/NIE.</p>
		<p>2. Fecha de nacimiento.</p>
		<p></p>
		<p>
			Asimismo, recabamos de los progenitores, tutores o representantes legales los datos de identificación (nombre y apellidos, NIF/Pasaporte/NIE), datos de contacto
			(teléfono y correo electrónico),<span>&nbsp; </span>su relación con el/la menor.
		</p>
		<p></p>
		<p>FINALIDADES PARA LAS QUE SE TRATAN SUS DATOS</p>
		<p>
			La recopilación de datos personales tiene con la finalidad de gestionar su participación en los distintos eventos organizados por la RFEF, gestión administrativa, gestión de
			cobros y pagos, realización de encuestas de opinión, así
			<span>&nbsp; </span>como para el envío de comunicaciones comerciales, incluso por medios electrónicos, sobre los distintos cursos, actividades y eventos organizados por la
			RFEF.
		</p>
		<p>
			Los datos de contacto de las personas mayores de edad únicamente serán tratados en caso de que fuese necesario para la gestión de cuestiones directamente relacionadas con el
			consentimiento otorgado.
		</p>
		<p></p>
		<p>BASE JURIDICA DEL TRATAMIENTO DE SUS DATOS</p>
		<p>
			La base jurídica del tratamiento de sus datos es su consentimiento.<span>&nbsp;</span>
		</p>
		<p>TRANSFERENCIAS INTERNACIONALES DE DATOS</p>
		<p>
			Los datos personales podrán ser transferidos a un tercer país o a una organización internacional en caso de que sea necesario para la finalidad perseguida. En todo caso se
			garantizará el cumplimiento de las disposiciones del Reglamento General de Protección de Datos y de la Ley Orgánica de Protección de Datos y Garantía de los Derechos
			Digitales.
		</p>
		<p>DERECHO A RETIRAR SU CONSENTIMIENTO</p>
		<p>Podrá retirar su consentimiento en cualquier momento. En este caso, sin embargo, podría ser imposible seguir manteniendo la relación de la RFEF con el/la menor.</p>
		<p>DESTINATARIOS A LOS QUE SE COMUNICARAN LOS DATOS</p>
		<p>
			La Real Federación Española de Fútbol no comunicará sus datos a terceros, salvo que sea imprescindible para la finalidad del tratamiento o previo requerimiento judicial o
			petición del Ministerio Fiscal o de las Administraciones Públicas en el ejercicio de sus potestades.
		</p>
		<p>PLAZO DE CONSERVACIóN DE SUS DATOS</p>
		<p>
			Los datos serán conservados durante el tiempo imprescindible en función de la finalidad para la que fueron facilitados o recabados, sin perjuicio de, en su caso, el ejercicio
			de su derecho de supresión.
		</p>
		<p>DERECHOS DE PROTECCIóN DE DATOS</p>
		<p>Podrá ejercer los derechos siguientes:</p>
		<p>
			Acceso, rectificación, supresión, oposición, portabilidad de los datos, derecho a no ser objeto de una decisión basada en el tratamiento automatizado de los datos, limitación
			del tratamiento de los datos.
		</p>
		<p>
			Para ejercer estos derechos podrá dirigirse por escrito, acreditando su identidad, a c/ Ramón y Cajal s/n, 28230 Las Rozas (Madrid) Responsable de Seguridad, área de
			Tecnología e Infraestructuras.
		</p>
		<p>DERECHO A PRESENTAR UNA RECLAMACIóN ANTE LA AGENCIA ESPAñOLA DE PROTECCIóN DE DATOS.</p>
		<p>
			Si considera que el tratamiento de datos personales que le conciernen infringe la normativa en vigor sobre protección de datos personales puede presentar una reclamación ante
			la Agencia Española de Protección de Datos, calle Jorge Juan, 6, 28001 Madrid (
			<a href="http://www.aepd.es/">
				<span>www.aepd.es</span>
			</a>
			)
		</p>
		<p></p>
		<p>TRATAMIENTO DE IMAGENES</p>
		<p>
			De acuerdo con Ley Orgánica 1/1982, de 5 de mayo, de protección civil del derecho al honor, a la intimidad personal y familiar y a la propia imagen, al marcar la casilla
			autorizo que las imágenes captadas del menor o la menor puedan ser utilizadas en redes sociales, medios de comunicación o en la Web de la RFEF con la finalidad de dar a
			conocer y promocionar las actividades en que participe el menor o la menor, con pleno respeto a sus derechos.
		</p>
		<p></p>
		<p>AUTORIZANDO el tratamiento de las imágenes.</p>
		<p></p>
		<p>Al AUTORIZAR el presente documento OTORGAN SU CONSENTIMIENTO EXPRESO para el tratamiento de sus datos personales en los términos en él contenidos</p>
	</div>
);

const responsability = (
	<div>
		<p>
			Por medio del presente <strong>AUTORIZO Y DECLARO:</strong>
		</p>
		<p>
			Mediante este documento a la Real Federación Española de Fútbol que el alumno no padece enfermedad o discapacidad física o psíquica por las cuales no pueda participar en el
			Curso de Tecnificación de la Escuela de la RFEF, el cual dará comienzo en octubre y finalizará en mayo. En adelante, el “curso” 
		</p>

		<p>
			Que, conforme a lo anterior, la Real Federación Española de Fútbol no será responsable por los daños derivados de cualquier tipo de actividad fruto de la participación del
			alumno en el Curso, renunciando expresamente por medio del presente documento a exigir responsabilidad alguna por las eventuales lesiones que pudieran derivarse como
			consecuencia de la practica ordinaria de la actividad deportiva del Curso.
		</p>

		<p>
			Que, por medio de la presente autorización doy mi expreso consentimiento para que el alumno reciba el tratamiento médico que pueda considerarse conveniente en caso de lesión,
			accidente y/o enfermedad durante el desarrollo del Curso, incluyendo, aquellas decisiones médico-quirúrgicas que, en caso de extrema urgencia y en las que no quepa consulta
			previa, fuese necesario adoptar, todo ello bajo la adecuada prescripción facultativa que correspondiere.
		</p>
	</div>
);

const imageConsent = (
	<div>
		<p>
			Por medio del presente <b>AUTORIZO Y DECLARO:</b>
		</p>
		<p>
			De acuerdo con Ley Orgánica 1/1982, de 5 de mayo, de protección civil del derecho al honor, a la intimidad personal y familiar y a la propia imagen, autorizo a
			la Real Federación Española de Fútbol a que utilice total o parcialmente de manera indefinidahasta revocación expresa, sin límite
			geográfico,en exclusiva y con facultad de cesión a terceros, la imagen y/o sonido del Alumno (incluido nombre, apellidos, y voz) como consecuencia de su
			participación en el Curso de Tecnificación de la Escuela de la RFEF, el cual dará comienzo el día XXXXXXXX y finalizará el día
			XXXXXXXXX a fin de que la misma sea divulgada en acciones promocionales y académicas de la RFEF por cualquier medio, incluida su página web y redes sociales.
		</p>
		<p>
			La presente autorización es de carácter gratuito y no se encuentra sometida a ningún plazo temporal ni restringida a ningún ámbito
			geográfico determinado, salvo lo dispuesto legalmente.
		</p>
		<p></p>
		<p>
			*Conforme a lo dispuesto en el art. 13 del Reglamento (UE) 2016/679, de Protección de Datos y en el art. 11 de la Ley Orgánica 3/2018, de Protección de
			Datos, se informa que los datos facilitados a través del presente formulario serán tratados por Real Federación Española de Fútbol, , para
			las finalidades que se desprenden del presente documento, teniendo este por objeto llevar a cabo la gestión de la autorización de la cesión de derechos
			de imagen, datos personales y derechos de propiedad intelectual. La base de legitimación del tratamiento de sus datos se encuentra en el consentimiento expreso e
			inequívoco manifestado por el tutor o representante legal en caso de tratarse de menores de edad. Los datos se conservarán durante el tiempo necesario para
			cumplir con la finalidad para la que se recabaron y para determinar las posibles responsabilidades que se pudieran derivar de dicha finalidad y del tratamiento de los datos.
			A los mismos efectos anteriores, garantiza que todos los datos personales contenidos en el presente documento puedan ser tratados, y consecuentemente, cedidos a los efectos
			de que pueda garantizarse la presente autorización sobre cesión de derechos de imagen. Para ejercitar los derechos de Acceso, Rectificación,
			Supresión, Limitación, Portabilidad o, en su caso, Oposición, no ser objeto de una decisión basada en el tratamiento automatizado de los datos o
			limitación del tratamiento, dirigiéndose por escrito, acreditando su identidad, a Plaza Luis Aragonés s/n, 28232 Las Rozas (Madrid) Responsable de
			Seguridad, área de Tecnología e Infraestructuras. o a la siguiente dirección de correo electrónico{" "}
			<a href="mailto:protecciondatos@rfef.es">
				<span>protecciondatos@rfef.es</span>
			</a>{" "}
			. En todo caso, podrá, igualmente, formular reclamaciones antela Agencia Española de Protección de datos (https://www.aepd.es/)
		</p>
	</div>
);

export default {
	dataConsent,
	responsability,
    imageConsent
};
